module.exports = __webpack_public_path__ + "static/media/Check_Done_Circular_Fill.c955b5f8.svg";